import classNames from 'clsx'
import { string } from 'prop-types'

import { formatPathWithLanguage } from 'shared/utils/url'
import ButtonCollapsible from 'views/components/molecules/ButtonCollapsible'
import useShopAndRuntimeConfig from 'views/enhancers/useShopAndRuntimeConfig'
import { downNavTreeType, upNavTreeType } from 'views/utils/propTypes'
import './CmsNavigationSection.scss'

const renderItem = (
  { category, index, length, reverse = false, icon = 'caretRight' },
  tenant,
  language
) => {
  const buttonProps = {
    href: formatPathWithLanguage(tenant)(language)(category.path),
    name: `category-mobile-button-${index}`,
    noBorder: true,
    reverse,
    icon,
  }

  const itemProps = {
    key: index,
  }

  if (index === 0) {
    buttonProps.position = 'first'
    itemProps.className = 'o-CmsNavigationSection--first-section-item'
  } else if (index === length - 1) {
    buttonProps.position = 'last'
    itemProps.className = 'o-CmsNavigationSection--last-section-item'
  } else {
    buttonProps.position = 'middle'
    itemProps.className = 'o-CmsNavigationSection--middle-section-item'
  }

  if (index !== length - 1) {
    itemProps.className = 'u-margin-xx-small--bottom'
  }

  itemProps.className = classNames(
    itemProps.className,
    'o-CmsNavigationSection--list-item'
  )

  return (
    <li {...itemProps}>
      <ButtonCollapsible {...buttonProps}>
        <span className="u-color--blue o-CmsNavigationSection--button-collapsible">
          {category.caption}
        </span>
      </ButtonCollapsible>
    </li>
  )
}

const renderList = (categories, title, tenant, language) => (
  <div className="u-margin-large--bottom" key={title}>
    <h2>{title}</h2>
    <ul className="a-list-reset">
      {categories.map((category, index) =>
        renderItem(
          { ...{ category, index, length: categories.length } },
          tenant,
          language
        )
      )}
    </ul>
  </div>
)

const renderUpNavigationSection = (navTree, tenant, language) => (
  <div className="u-margin-large--bottom">
    <ul className="a-list-reset">
      {navTree.map((category, index) =>
        renderItem(
          {
            ...{
              category,
              index,
              length: navTree.length,
              reverse: true,
              icon: 'caretLeft',
            },
          },
          tenant,
          language
        )
      )}
    </ul>
  </div>
)

const renderDownNavigationSection = (title, navTree, tenant, language) => {
  const categoriesWithoutSubCategories = navTree.filter(
    category => !category.down || category.down.length === 0
  )
  const categoriesWithSubCategories = navTree.filter(
    category => category.down && category.down.length > 0
  )

  return (
    <>
      {categoriesWithoutSubCategories.length > 0 &&
        renderList(categoriesWithoutSubCategories, title, tenant, language)}
      {categoriesWithSubCategories.length > 0 &&
        categoriesWithSubCategories.map(category =>
          renderList(category.down, category.caption, tenant, language)
        )}
    </>
  )
}

const CmsNavigationSection = ({
  upNavTree,
  secondaryNavTitle,
  secondaryNavTree,
}) => {
  const {
    publicRuntimeConfig: {
      publicConfig: { tenant, language },
    },
  } = useShopAndRuntimeConfig()
  return (
    <>
      {upNavTree.length > 0 &&
        renderUpNavigationSection(upNavTree, tenant, language)}
      {secondaryNavTree.length > 0 &&
        renderDownNavigationSection(
          secondaryNavTitle,
          secondaryNavTree,
          tenant,
          language
        )}
    </>
  )
}

CmsNavigationSection.propTypes = {
  upNavTree: upNavTreeType,
  secondaryNavTitle: string.isRequired,
  secondaryNavTree: downNavTreeType,
}

CmsNavigationSection.defaultProps = {
  upNavTree: [],
  secondaryNavTree: [],
}

export default CmsNavigationSection
